// removed by extract-text-webpack-plugin
module.exports = {"body-wrapper":"layout__body-wrapper___Z_yhQ","header-wrapper":"layout__header-wrapper___3k5_E","content-wrapper":"layout__content-wrapper___11sSP","footer-wrapper":"layout__footer-wrapper___2wI8c","setup-content-layout-wrapper":"layout__setup-content-layout-wrapper___13gLU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/layout.less
// module id = 346
// module chunks = 3